import { IPostGeneralStocksResult } from '@/fsd/entities/remains/model/types/IPostGeneralStocksResult';
import { prepareColumn } from '@/fsd/entities/table/ui/TableItem/TableItem';
import BodyTableLine from '@/fsd/shared/ui/BodyTableLine';
import BodyTableLineItem from '@/fsd/shared/ui/BodyTableLineItem';
import { observer } from 'mobx-react-lite';
import { getRemainsTableTotalItemWidth } from '../../../lib/helpers/getRemainsTableTotalItemWidth';
import RemainsStore from '../../../model/store/RemainsStore';
import styles from './RemainsTableTotalRow.module.scss';

interface IProps {
  data: IPostGeneralStocksResult;
}

export const RemainsTableTotalRow = observer(({ data }: IProps) => {
  const { columns } = RemainsStore;
  const visibleColumns = columns.filter((c) => c.isVisible);
  const totalLabelColumns = ['product_id', 'photo_url', 'name'];
  const columnsForTotals = visibleColumns.filter(
    (c) => !totalLabelColumns.includes(c.id)
  );
  return (
    <BodyTableLine items="totalRow" className={styles.totalRow}>
      <BodyTableLineItem
        value="Всего:"
        style={{ width: getRemainsTableTotalItemWidth(columns) }}
        className={styles.totalTitle}
      />
      {columnsForTotals.map((column) => {
        let value = null;
        let item = null;

        if (column.id === 'total_stock') {
          item = { total_stock: data.totals.total.quantity };
        } else if (column.id === 'total_cost') {
          item = { total_cost: data.totals.total.cost };
        } else if (column.type === 'warehouse') {
          item = { warehouses: data.totals.local.warehouses };
        } else if (column.id === 'wb_fbo_total') {
          item = { wb_fbo_total: data.totals.wb_fbo.quantity };
        } else if (column.id === 'ozon_fbo_total') {
          item = { ozon_fbo_total: data.totals.ozon_fbo.quantity };
        } else if (column.id === 'wb_fbs_total') {
          item = { wb_fbs_total: data.totals.wb_fbs.quantity };
        } else if (column.id === 'ozon_fbs_total') {
          item = { ozon_fbs_total: data.totals.ozon_fbs.quantity };
        }


        if (item) {
          value = prepareColumn(item, column);
        }

        return (
          <BodyTableLineItem
            key={column.id}
            value={value}
            style={{ width: `${column.width}px` }}
          />
        );
      })}
    </BodyTableLine>
  );
});
